import './assets/main.css'
import 'primeicons/primeicons.css'
import PrimeVue from 'primevue/config';
import Toast from "vue-toastification";
import 'vue-toastification/dist/index.css'


import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

const app = createApp(App)
app.config.devtools = true;

app.use(createPinia())
app.use(router)
app.use(PrimeVue)
app.use(Toast , {
  position: "bottom-left",})

app.mount('#app')
